import { useAtomsDevtools } from 'jotai-devtools'
import type { createStore } from 'jotai/index'
import type { FC } from 'react'

type Props = { store: ReturnType<typeof createStore> }

function DevTools({ store }: Props) {
  useAtomsDevtools('dev', { store })
  return null
}

function ProdTools(_: Props) {
  return null
}

export const AtomDevTools: FC<Props> =
  import.meta.env.DEV && typeof window !== 'undefined' ? DevTools : ProdTools
